import { useQuery } from '@tanstack/react-query';
import { billingService, queryKeys } from '@/services';

/**
 * The counterparty's period document, addressed by any member statement id
 * (LR-557). The document page and the list's expandable rows share the cache
 * entry when addressed by the SAME id; a sibling statement of the same
 * document is a different key and fetches its own copy.
 */
export const useBillingStatementDocument = (
  id: number | null,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: queryKeys.billing.statementDocument(id ?? -1),
    queryFn: () => billingService.getStatementDocument(id as number),
    enabled: enabled && id !== null,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
